// material-ui
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// project import
import { useUserInfo } from 'hooks/useUserInfo';

// assets
import { BarChartOutlined } from '@ant-design/icons';

// react-router
import { useNavigate } from 'react-router-dom';

// ==============================|| HEADER CONTENT - ADMIN BUTTON ||============================== //

export default function AdminButton() {
  const { isAdmin } = useUserInfo();
  const navigate = useNavigate();

  // Only show for signed-in users with admin role (not affected by impersonation)
  if (!isAdmin) {
    return null;
  }

  const handleAdminClick = () => {
    navigate('/admin');
  };

  return (
    <Tooltip title="Admin Dashboard">
      <IconButton
        color="secondary"
        onClick={handleAdminClick}
        sx={{ color: 'text.primary' }}
      >
        <BarChartOutlined />
      </IconButton>
    </Tooltip>
  );
}
